var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 88,
    viewBox: "0 0 87 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337",
    transform: "translate(-288 -356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_469",
    "data-name": "Ellipse 469",
    cx: 43.5,
    cy: 44,
    rx: 43.5,
    ry: 44,
    transform: "translate(288 356)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "play-solid",
    d: "M38.971,20.192,9.705,4.537a2.462,2.462,0,0,0-2.486.17A2.839,2.839,0,0,0,6,7.031v31.3a2.827,2.827,0,0,0,1.233,2.387,2.45,2.45,0,0,0,2.548.107l29.19-15.655a2.882,2.882,0,0,0,0-4.989Z",
    transform: "translate(312.343 376.675)",
    fill: "#fff",
    opacity: 0.86
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.5749deed75e14723e2b40382fca5ae00.svg";
export { ForwardRef as ReactComponent };